export default "__VITE_ASSET__DfviDtfS__"